module.exports = __webpack_public_path__ + "static/img/7.d7e29f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/7.png
// module id = lODP
// module chunks = 0